module.exports = __webpack_public_path__ + "static/img/2.cbf3d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/11/2.png
// module id = zw+S
// module chunks = 2